import React, { useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
// logo
 import logoGreen from "../assets/logo.png";
// second column image
import manCuttingTimber from "../assets/pattern@2x.png";
import pattern from '../assets/pattern.png';
import logo from '../assets/TCL_white.png';
import mask from '../assets/Image@2x.png';
const Auth = () => {
  const { pathname } = useLocation();
  // checking if the current location is login
  // const isLogin = useMemo(() => pathname === "/login", [pathname]);
  return (
    <div className="h-screen w-screen flex relative">
      {/* the header will come later */}

      {/* first inner div */}
      <div className="h-full flex-1 flex flex-col justify-center items-center p-6 lg:p-0 ">
        <div className="absolute w-full md:w-[30rem] top-0 p-6 lg:px-0">
          <img src={logoGreen} alt="tcl" className="h-20 w-auto object-contain" />
        </div>
        <Outlet />
      </div>

      {/* second inner div */}
      <div
        className={`hidden md:block flex-1 bg-[#3e7c17]  bg-cover bg-no-repeat bg-top-center `}
        style={{
          backgroundImage: `url(${mask})`,
        }}
      >
        <img src={pattern} alt="tcl" className="object-right-top h-auto w-auto object-none" />

      </div>
    </div>
  );
};

export default Auth;

// old sign up reroute
/* <div className="my-3">
          {isLogin ? (
            <span className="text-gray-700">
              Don't have an Account?{" "}
              <Link to="/signup" className="text-indigo-700">
                Sign Up
              </Link>
            </span>
          ) : (
            <span>
              Already have an Account?{" "}
              <Link to="/login" className="text-indigo-700">
                Login
              </Link>
            </span>
          )}
 </div> */
